import React from 'react';
import '../grid/loader.css';

export default class FormLoader extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loaders: []
        };

        this.unmount = false;
        this.setNext = this.setNext.bind(this);
    }

    componentDidMount() {
        this.interval = this.setNext();
    }

    setNext() {
        setTimeout(() => {
            if (this.unmount) return;

            let loaders = this.state.loaders;
            loaders.push(<div className={'formLoadBlock'}><div className='fieldHolder'></div></div>);
            if (loaders.length > 8) loaders = [];

            this.setState({loaders});
            this.interval = this.setNext();
        }, 300);
    }

    componentWillUnmount() {
        this.unmount = true;
    }

    render() {
        return (
            <div style={{height: '500px', marginTop: '20px', padding: '20px'}}>
                {this.state.loaders.map((item, key) => <div className='col-md-6' key={key}>{item}</div>)}
            </div>
        );
    }
}